"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsGoogleDriveFileBinary;

var _file = require("FileManagerCore/utils/file");

// A non binary file does not have an extension.
// Non binary files are files created through Google; example Google Slides, or Google Docs.
function getIsGoogleDriveFileBinary(doc) {
  return (0, _file.splitNameAndExtension)(doc).extension !== '';
}

module.exports = exports.default;